"use strict";
// @ts-ignore
try {
    self['workbox:window:5.1.2'] && _();
}
catch (e) { }
